import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import { spawn } from 'redux-saga/effects';

import behavior from './reducers/behaviorReducer';
import messages from './reducers/messagesReducer';
import quickButtons from './reducers/quickButtonsReducer';
import preview from './reducers/fullscreenPreviewReducer';
import responses from './reducers/responsesReducer';
import files from './reducers/fileContentsReducer';
import campaign from './reducers/campaignReducer';
import { messagesSaga } from './sagas/messagesSaga';
import createSagaMiddleware from 'redux-saga';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers =
  (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const reducer = combineReducers({ behavior, messages, quickButtons, preview, responses, files, campaign });

const sagaMiddleware = createSagaMiddleware();

function* rootSaga() {
  yield spawn(messagesSaga);
}

const store = createStore(reducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(rootSaga);
export default store;
